module.exports = __webpack_public_path__ + "img/lingyong.0eb35ff7.png";